import { render, staticRenderFns } from "./topic-list.vue?vue&type=template&id=20bcfbac"
import script from "./topic-list.vue?vue&type=script&lang=js"
export * from "./topic-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20bcfbac')) {
      api.createRecord('20bcfbac', component.options)
    } else {
      api.reload('20bcfbac', component.options)
    }
    module.hot.accept("./topic-list.vue?vue&type=template&id=20bcfbac", function () {
      api.rerender('20bcfbac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/topic-list.vue"
export default component.exports